
const m = window.require("discourse/helpers/node");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
